export enum ERoom {
  /** Койко-место **/
  Bed = 'bed',
  /** Пятикомнатная квартира **/
  FiveRoom = 'fiveRoom',
  /** Четырехкомнатная квартира **/
  FourRoom = 'fourRoom',
  /** Многокомнатная квартира (6 и более комнат) **/
  Large = 'large',
  /** Однокомнатная квартира **/
  OneRoom = 'oneRoom',
  /** Квартира со свободной планировкой **/
  OpenPlan = 'openPlan',
  /** Комната **/
  Room = 'room',
  /** Доля в квартире **/
  Share = 'share',
  /** Студия **/
  Studio = 'studio',
  /** Трехкомнатная квартира **/
  ThreeRoom = 'threeRoom',
  /** Двухкомнатная квартира **/
  TwoRoom = 'twoRoom',
}

export type TNumberInputs = number | undefined;

export interface IFilter {
  deadlineVariants: number[];
  locationVariants: number[];
  deadline: TNumberInputs | 'any';
  minPrice: TNumberInputs;
  maxPrice: TNumberInputs;
  location: number;
  rooms: ERoom[];
  minArea: TNumberInputs;
  maxArea: TNumberInputs;
  apartmentsWithDecoration: boolean;
  readyApartments: boolean;
}
